import React, { useEffect, useRef, useState } from "react";
import ChartComp from "../components/chart/Chart";
import { toast } from "react-toastify";
import PageContainer from "../components/pages/PageContainer";
import { getCandlestickData } from "../utils/api";
import {
  addChartNotification,
  deleteSavedChart,
  getChartStockDetails,
  getFollowersListApi,
  getSavedCharts,
  s3SingleUpload,
  saveChart,
  shareCartAsPostApi,
  shareSavedChartApi,
  trackViewContent,
} from "../api/user";
import { initialValue, saveStateToLocalStorage } from "../utils/localstorage";
import "react-toastify/dist/ReactToastify.css";
import Annotation from "../components/setting/Annotation";
import ChartSettingsControl from "../components/setting/ChartSettingsControl";
import ChartType from "../components/setting/ChartType";
import Overlays from "../components/setting/Overlays";
import Indicators from "../components/setting/Indicators";
import html2canvas from "html2canvas";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import { useOutletContext } from "react-router";
import Loader from "../components/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { StockSummary } from "../components/chart/stockSummary";
import { ChartToolBar } from "../components/chart/chartToolBar";
import { TimeRangeButton } from "../components/chart/timeRangeButton";
import { SavedCharts } from "../components/chart/savedCharts";
import { SaveChartImage } from "../components/chart/saveChartImage";
import { ChartError } from "../components/chart/chartError";
import { ChartActionButtons } from "../components/chart/chartActionButtons";
import { ChartTopSummary } from "../components/chart/chartTopSummary";
import { AddNotification } from "../components/chart/addNotification";
import FollowersListModal from "../components/Modals/followersListModal";
import { fetchChartsData } from "./fetchChartsData";
import { sleep } from "../utils/utils";
import $ from "jquery";

const Char = () => {
  const [setting, setSetting] = useState(initialValue);
  const [data, setData] = useState([]);
  const [gridSetting, setGridSetting] = useState({
    style: "ShortDot",
    opacity: "0.1",
    strokeWidth: "2",
    grid: false,
  });
  const captureRef = React.useRef();
  const [stockData, setstockData] = useState(null);
  const [isParamsSubmit, setIsParamSubmit] = useState(false);
  const [isIndicatorSubmit, setIsIndicatorSubmit] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isOverlaySubmit, setIsOverlaySubmit] = useState(false);
  const [overlays, setOverlays] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [indicatorConfig, setIndicatorConfig] = useState([]);
  const [candleStick, setCandleStick] = useState([]);
  const [loader, setloader] = useState(false);
  const [overlayloader, setOverlayloader] = useState(false);
  const [indicatorloader, setIndicatorloader] = useState(false);
  const drawingCanva = useRef();
  const [error, seterror] = useState("");
  const [activeTab, setActiveTab] = useState(1);
  const [price, setPrice] = useState("");
  let tickerFromLocalStorage = localStorage.getItem("ticker") || 'SPY';
  const [loaders, setloaders] = useState(true);
  const [savedCharts, setSavedCharts] = useState([]);
  const [preview, setPreview] = useState(false);
  const [preview1, setPreview1] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const [activeImage1, setActiveImage1] = useState(
    localStorage.getItem("tickerEventImage") || ""
  );
  const [isSlide, setIsSlide] = useState(false);
  const [sidebarToggle] = useOutletContext();
  const [stockPrice, setStockPrice] = useState("");
  const [quotes, setQuotes] = useState(null);
  const [followersList, setFollowersList] = useState([]);
  const [isFollowersOpen, setIsFollowersOpen] = useState(false);
  const [shareChartData, setShareChartData] = useState({});
  const [shareChartData1, setShareChartData1] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const initialState = {
    selectValue: "",
    inputValue: "",
    selectPosValue: "above",
  };
  const [rows, setRows] = useState([initialState]);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [chartId, setChartId] = useState(null); // State to store chart id

  const [dropdownStates1, setDropdownStates1] = useState(
    savedCharts.map(() => false)
  );

  const toggleDropdown1 = (index) => {
    const newDropdownStates = [...dropdownStates1];
    newDropdownStates[index] = !newDropdownStates[index];
    setDropdownStates1(newDropdownStates);
  };

  useEffect(() => {
    if (localStorage.getItem("tickerEventImage")) {
      setPreview1(true);
    }
  }, []);

  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      localStorage.setItem("tickerEventImage", event?.detail?.imageChart);
      setPreview1(true);
      setActiveImage1(event?.detail?.imageChart);
    };
    window.addEventListener("tickerEventImage", handleCustomProfileEvent);
  }, [window.addEventListener]);

  const handleShareToFollowers = async (id, index) => {
    setSelectedIndices([...selectedIndices, index]);
    const obj = {
      chart_id: shareChartData1?.id ? shareChartData1?.id : shareChartData?.id,
      users: id,
    };
    const res = await shareSavedChartApi(obj);
    if (res?.data?.status === 200) {
    } else {
      setSelectedIndices(selectedIndices.filter((i) => i !== index));
      toast.error(res?.data?.message);
    }
  };

  const handleShareCancel = () => {
    setIsFollowersOpen(false);
    setSelectedIds([]);
    setSelectedIndices([]);
  };

  const onShareChartClick = (chart) => {
    setShareChartData(chart);
    setIsFollowersOpen(true);
    setPreview(false);
    setSelectedIds([]);
  };

  const shareChartAsPost = async (chart) => {
    setChartId(chart?.id);
    setShowModalChart(true);
  };
  const [inputValue, setInputValue] = useState("");

  const [sharingInProgress, setSharingInProgress] = useState(false);

  const handleShare = async () => {
    // If sharing is already in progress, return early to prevent multiple clicks
    if (sharingInProgress) return;

    setSharingInProgress(true); // Set flag to indicate sharing is in progress

    try {
      const res = await shareCartAsPostApi(
        shareChartData1?.id || chartId,
        inputValue
      );
      if (res?.data?.status === 200) {
        setPreview(false);
        setSelectedIds([]);
        setShowModalChart(false);
        toast.success(res?.data?.message);
        setInputValue("");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error("Error sharing cart:", error);
      toast.error("An error occurred while sharing the cart.");
    } finally {
      setSharingInProgress(false); // Reset the flag whether successful or not
    }
  };
  useEffect(() => {
    getFollowersList();
  }, []);

  const getFollowersList = async () => {
    try {
      const res = await getFollowersListApi();
      if (res?.data?.status === 200) {
        setFollowersList(res?.data?.data?.data);
      }
    } catch (err) { }
  };

  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      if (event?.detail?.ticker) {
        setSetting({
          ...setting,
          symbol: event?.detail?.ticker,
          adlValue: "",
          adxValue: "",
          cciValue: "",
          cmfValue: "",
          macdValue: "",
          macdhValue: "",
          mfiValue: "",
          obvValue: "",
          ppoValue: "",
          pvoValue: "",
          rocValue: "",
          efiValue: "",
          stochValue: "",
          rsiValue: "",
          clearIndicator: true,
        });
        setRows([{ selectValue: "", inputValue: "", selectPosValue: "above" }]);
        localStorage.setItem("ticker", event?.detail?.ticker);
        // tickerFromLocalStorage = event?.detail?.ticker;
        return tickerFromLocalStorage;
      }
    };
    window.addEventListener("tickerEvent", handleCustomProfileEvent);
  }, [window.addEventListener]);

  const handlePreview1Close = () => {
    setPreview1(false);
    localStorage.removeItem("tickerEventImage");
  };

  useEffect(() => {
    const fetchData = async () => {
      const stock = tickerFromLocalStorage
        ? tickerFromLocalStorage
        : setting.symbol;
      try {
        setloaders(true);
        // const response = await getChartStockDetails(stock);
                const searchString = stock?.toUpperCase() || "SPY";

    const category =
      searchString.startsWith("C:") ? "Forex" :
      searchString.startsWith("X:") ? "Crypto" :
      "Stocks";

    const response = await getChartStockDetails({
      ticker: searchString,
      category: category,
    });
        console.log(response.data.data,'latest');
        if (response?.data?.data?.ticker?.name) {
          setstockData(response.data.data);
          setloaders(false);
        } else {
          setloaders(false);
        }
      } catch (error) {
        setloaders(false);
        console.error("Error:", error);
      }
    };

    fetchData();
  }, [setting.symbol, tickerFromLocalStorage]);

  const handleInputChange = (event) => {
    setPrice(event.target.value);
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const handleAPICall = async () => {
    const priceP = price.trim();
    if (!priceP) {
      toast.error("The amount field is required");
      return;
    }
    setloaders(true);
    const data = {
      stock_symbol: tickerFromLocalStorage
        ? tickerFromLocalStorage
        : setting.symbol,
      notificaion_type: activeTab,
      amount: price.trim(),
    };
    try {
      const response = await addChartNotification(data);
      if (response) {
        setloaders(false);
        setPrice("");
        setIsNotificationOpen(false);
        toast.success(response.data.message);
      }
    } catch (error) {
      setloaders(false);
      toast.error(error.response.data.message);
      console.error("Error:", error);
    }
  };
  const handleSaveNotification = () => {
    setIsNotificationOpen(false);
  };
  const handleClose = () => {
    setIsNotificationOpen(false);
  };

  const [isWidth, setISWidth] = useState(window.innerWidth < 890);
  useEffect(() => {
    setISWidth(window.innerWidth < 890);
  }, [window.innerWidth]);

  const checkForMobileDevice = () => {
    return /Mobi|Android/i.test(window.navigator.userAgent);
  };


useEffect(() => {
  trackViewContent();
}, []);


  useEffect(() => {
    // Check if the user is on a mobile device
    if (checkForMobileDevice()) {
      setSetting({ ...setting, isMobile: true });
    } else {
      setSetting({ ...setting, isMobile: false });
    }
  }, []);

  const base64toFile = (base64String, filename) => {
    const byteString = atob(base64String.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: "image/jpeg" });
    return new File([blob], filename, { type: "image/jpeg" });
  };

  const captureElement_BKP = async () => {
    if (captureRef.current) {
      // console.log(captureRef.current, "capture");
      setloaders(true);
      html2canvas(captureRef.current).then(async (canvas) => {
        const image = canvas.toDataURL("image/png");
        const file = base64toFile(image, "file.jpg");
        const res = await s3SingleUpload(file);
        if (res?.data?.status === 200) {
          const convertedArray = res?.data?.data.map((str) => ({ image: str }));
          const res1 = await saveChart(
            convertedArray,
            tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol
          );
          if (res1?.data?.status === 200) {
            setloaders(false);
            toast.success(res1.data.message);
            fetchSavedCharts();
          } else {
            setloaders(false);
            toast.error(res1.data.message);
          }
        } else {
          setloaders(false);
          toast.error(res.data.message);
        }
      });
    }
  };

  const setLegendItemsMargins = (isSet = false) => {
    const textElements = document.querySelectorAll(".legend-item-text");
    const colorElements = document.querySelectorAll(".legend-item-color");

    if (isSet) {
      textElements.forEach((element) => {
        element.style.marginTop = "-10.5px"; // Adjust the value as needed
      });

      colorElements.forEach((element) => {
        element.style.marginTop = "2px"; // Adjust the value as needed
      });
    } else {
      textElements.forEach((element) => {
        element.style.marginTop = ""; // Adjust the value as needed
      });

      colorElements.forEach((element) => {
        element.style.marginTop = ""; // Adjust the value as needed
      });
    }
  };

  const captureElement = async () => {
    if (captureRef.current) {
      // console.log(captureRef.current, "capture");
      setloaders(true);
      setLegendItemsMargins(true);
      html2canvas(captureRef.current).then(async (canvas) => {
        const image = canvas.toDataURL("image/png");
        const file = base64toFile(image, "file.jpg");
        const res = await s3SingleUpload(file);
        setLegendItemsMargins();
        if (res?.data?.status === 200) {
          const convertedArray = res?.data?.data.map((str) => ({ image: str }));
          const res1 = await saveChart(
            convertedArray,
            tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol
          );
          if (res1?.data?.status === 200) {
            setloaders(false);
            toast.success(res1.data.message);
            fetchSavedCharts();
          } else {
            setloaders(false);
            toast.error(res1.data.message);
          }
        } else {
          setloaders(false);
          toast.error(res.data.message);
        }
      });
    }
  };

  const {
    fetchBollingerData,
    fetchPsarData,
    fetchSmaData,
    fetchEmaData,
    fetchAdlData,
    fetchAdxData,
    fetchRSIData,
    fetchStochData,
    fetchMacdhData,
    fetchCCIData,
    fetchPPOData,
    fetchCMFData,
    fetchPVOData,
    fetchMACDData,
    fetchMFIData,
    fetchROCData,
    fetchOBVData,
    fetchEFIData,
  } = fetchChartsData(
    tickerFromLocalStorage,
    setting,
    setOverlays,
    setOverlayloader,
    seterror,
    setIndicators,
    setIndicatorloader
  );

  useEffect(() => {
    const fetchOverlayData = async () => {
      if (isOverlaySubmit) {
        setIsOverlaySubmit(!isOverlaySubmit);
        try {
          for (const item of setting.overlayParams) {
            let index = setting.overlayParams.indexOf(item);
            if (
              item.inputValue === undefined ||
              item.inputValue === "" ||
              item.selectValue === ""
            ) {
              continue;
            }
            setOverlayloader(true);
            if (item.selectValue === "bb" && item.inputValue !== "") {
              fetchBollingerData(item, index);
            }
            if (item.selectValue === "sma" && item.inputValue !== "") {
              fetchSmaData(item, index);
            }
            if (item.selectValue === "ema" && item.inputValue !== "") {
              fetchEmaData(item, index);
            }
            if (item.selectValue === "psar" && item.inputValue !== "") {
              fetchPsarData(item, index);
            }
          }
        } catch (error) {
          toast.error(error?.response?.data?.error || error?.message);
          setOverlayloader(false);
          seterror(error?.message);
          console.error("Error fetching Bollinger Bands data:", error);
        }
      }
    };

    fetchOverlayData();
  }, [isOverlaySubmit, isParamsSubmit]);

  useEffect(() => {
    const fetchIndicatorData = async () => {
      for (const item of setting.indicatorParams) {
        await sleep(250);
        let index = setting.indicatorParams.indexOf(item);
        if (
          item.inputValue === undefined ||
          item.inputValue === "" ||
          item.selectValue === ""
        ) {
          continue;
        }
        setIndicatorloader(true);

        if (item.selectValue === "adl" && item.inputValue !== "") {
          fetchAdlData(item, index);
        }
        if (item.selectValue === "macdh" && item.inputValue !== "") {
          fetchMacdhData(item, index);
        }
        if (item.selectValue === "stoch" && item.inputValue !== "") {
          fetchStochData(item, index);
        }
        if (item.selectValue === "rsi" && item.inputValue !== "") {
          fetchRSIData(item, index);
        }
        if (item.selectValue === "adx" && item.inputValue !== "") {
          fetchAdxData(item, index);
        }
        if (item.selectValue === "cci" && item.inputValue !== "") {
          fetchCCIData(item, index);
        }
        if (item.selectValue === "macd" && item.inputValue !== "") {
          fetchMACDData(item, index);
        }
        if (item.selectValue === "mfi" && item.inputValue !== "") {
          fetchMFIData(item, index);
        }
        if (item.selectValue === "obv" && item.inputValue !== "") {
          fetchOBVData(item, index);
        }
        if (item.selectValue === "ppo" && item.inputValue !== "") {
          fetchPPOData(item, index);
        }
        if (item.selectValue === "efi" && item.inputValue !== "") {
          fetchEFIData(item, index);
        }
        if (item.selectValue === "roc" && item.inputValue !== "") {
          fetchROCData(item, index);
        }
        if (item.selectValue === "pvo" && item.inputValue !== "") {
          fetchPVOData(item, index);
        }
        if (item.selectValue === "cmf" && item.inputValue !== "") {
          fetchCMFData(item, index);
        }
      }
    };
    fetchIndicatorData();
  }, [isIndicatorSubmit, isParamsSubmit]);

  useEffect(() => {
    const fetchIndicatorData = async () => {
      let updateList = [];
      try {
        for (const item of setting.indicatorParams) {
          let index = setting.indicatorParams.indexOf(item);
          if (
            item.inputValue === undefined ||
            item.inputValue === "" ||
            item.selectValue === ""
          ) {
            continue;
          }
          let indicatorItem = {
            id: "",
            yAccessor: "",
            strokeStyle: "",
            yExtents: "",
            position: "",
            lineConfig: [],
          };
          if (item.selectValue === "adl" && item.inputValue !== "") {
            indicatorItem.id = "ADL";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d?.indicators[index]?.adl?.ad;
            indicatorItem.yExtents = (d) => d?.indicators[index]?.adl?.ad;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d?.indicators[index]?.adl?.ad,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "macdh" && item.inputValue !== "") {
            indicatorItem.id = "MACDH";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.macdh?.macdh;
            indicatorItem.yExtents = (d) => d.indicators[index]?.macdh?.macdh;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: false,
                yAccessor: (d) => d.indicators[index].macdh?.macdh,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "stoch" && item.inputValue !== "") {
            indicatorItem.id = "STOCH";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.stoch?.stoch;
            indicatorItem.yExtents = (d) => d.indicators[index]?.stoch?.stoch;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.stoch?.stoch,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "rsi" && item.inputValue !== "") {
            indicatorItem.id = "RSI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.rsi?.rsi;
            indicatorItem.yExtents = (d) => d.indicators[index]?.rsi?.rsi;
            indicatorItem.strokeStyle = "#ff7f0e";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.rsi?.rsi,
                strokeStyle: "#ff7f0e",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "adx" && item.inputValue !== "") {
            indicatorItem.id = "ADX";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.adl?.adx;
            indicatorItem.yExtents = (d) => [
              Math.min(
                d.indicators[index]?.adx?.adx,
                d.indicators[index]?.adx?.dmn,
                d.indicators[index]?.adx?.dmp
              ),
              Math.max(
                d.indicators[index]?.adx?.adx,
                d.indicators[index]?.adx?.dmn,
                d.indicators[index]?.adx?.dmp
              ),
            ];
            indicatorItem.strokeStyle = "#2ca02c";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.adx?.adx,
                strokeStyle: "#00FF00",
              },
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.adx?.dmn,
                strokeStyle: "#0000FF",
              },
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.adx?.dmp,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "cci" && item.inputValue !== "") {
            indicatorItem.id = "CCI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.cci?.cci;
            indicatorItem.yExtents = (d) => d.indicators[index]?.cci?.cci;
            indicatorItem.strokeStyle = "#FF00FF";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.cci?.cci,
                strokeStyle: "#FF00FF",
              },
            ];
            updateList.push(indicatorItem);
          }

          if (item.selectValue === "fi" && item.inputValue !== "") {
            setting.enableSSAR = true;
          }
          if (item.selectValue === "macd" && item.inputValue !== "") {
            indicatorItem.id = "MACD";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index].macd.macd;
            indicatorItem.yExtents = (d) => [
              Math.min(
                d.indicators[index]?.macd?.macd,
                d.indicators[index]?.macd?.macdh,
                d.indicators[index]?.macd.macds
              ),
              Math.max(
                d.indicators[index]?.macd?.macd,
                d.indicators[index]?.macd?.macdh,
                d.indicators[index]?.macd.macds
              ),
            ];
            indicatorItem.strokeStyle = "#FFC0CB";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.macd?.macd,
                strokeStyle: "#00FF00",
              },

              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.macd?.macds,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "mfi" && item.inputValue !== "") {
            indicatorItem.id = "MFI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.mfi?.mfi;
            indicatorItem.yExtents = (d) => d.indicators[index]?.mfi?.mfi;
            indicatorItem.strokeStyle = "#FF0000";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.mfi?.mfi,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "obv" && item.inputValue !== "") {
            indicatorItem.id = "OBV";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.obv?.obv;
            indicatorItem.yExtents = (d) => d.indicators[index]?.obv?.obv;
            indicatorItem.strokeStyle = "#800080";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.obv?.obv,
                strokeStyle: "#800080",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "ppo" && item.inputValue !== "") {
            indicatorItem.id = "PPO";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.ppo?.ppo;
            indicatorItem.yExtents = (d) => d.indicators[index]?.ppo?.ppo;
            indicatorItem.strokeStyle = "#FF0000";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.ppo?.ppo,
                strokeStyle: "#FF0000",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "efi" && item.inputValue !== "") {
            indicatorItem.id = "EFI";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.efi?.efi;
            indicatorItem.yExtents = (d) => d.indicators[index]?.efi?.efi;
            indicatorItem.strokeStyle = "#0000FF";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.efi?.efi,
                strokeStyle: "#0000FF",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "roc" && item.inputValue !== "") {
            indicatorItem.id = "ROC";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.roc?.roc;
            indicatorItem.yExtents = (d) => d.indicators[index]?.roc?.roc;
            indicatorItem.strokeStyle = "#2ca02c";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.roc?.roc,
                strokeStyle: "#2ca02c",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "pvo" && item.inputValue !== "") {
            indicatorItem.id = "PVO";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.pvo?.pvo;
            indicatorItem.yExtents = (d) => d.indicators[index]?.pvo?.pvo;
            indicatorItem.strokeStyle = "#FFA500";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.pvo?.pvo,
                strokeStyle: "#FFA500",
              },
            ];
            updateList.push(indicatorItem);
          }
          if (item.selectValue === "cmf" && item.inputValue !== "") {
            indicatorItem.id = "CMF";
            indicatorItem.data = indicators?.[index]?.data;
            indicatorItem.yAccessor = (d) => d.indicators[index]?.cmf?.cmf;
            indicatorItem.yExtents = (d) => d.indicators[index]?.cmf?.cmf;
            indicatorItem.strokeStyle = "#00FF00";
            indicatorItem.position = item.selectPosValue;
            indicatorItem.lineConfig = [
              {
                lineType: true,
                yAccessor: (d) => d.indicators[index]?.cmf?.cmf,
                strokeStyle: "#00FF00",
              },
            ];
            updateList.push(indicatorItem);
          }
        }
        setIndicatorConfig(updateList);
      } catch (error) {
        toast.error(error?.response?.data?.error || error?.message);
        setIndicatorloader(false);
        seterror(error?.message);
        console.error("Error fetching indicator data:", error);
      }
    };

    fetchIndicatorData();
  }, [indicators]);

  useEffect(() => {
    const fetchCandlestickData = async () => {
      const candlestickParams = {
        symbol: tickerFromLocalStorage
          ? tickerFromLocalStorage
          : setting.symbol,
        startDate: setting.startDate,
        period: setting.period,
        multiplier: setting?.multiplier,
      };
      try {
        setloader(true);
        if (setting.indicatorParams.length > 0) {
          setIsIndicatorSubmit(!isIndicatorSubmit);
        }
        if (setting.overlayParams.length > 0) {
          setIsOverlaySubmit(!isOverlaySubmit);
        }
        const data = await getCandlestickData(
          ...Object.values(candlestickParams)
        );
        setCandleStick(data);
      } catch (error) {
        setSetting(initialValue);
        setCandleStick([]);
        toast.error("Something went wrong, please refresh the screen");
        seterror("Something went wrong, please refresh the screen");
        setloader(false);
        console.error(
          "Error fetching Candlestick data:",
          error.response.data.error || error.message
        );
      }
    };
    if (tickerFromLocalStorage || setting?.symbol) {
      fetchCandlestickData();
    }
  }, [isParamsSubmit, tickerFromLocalStorage, setting?.symbol]);

  useEffect(() => {
    fetchSavedCharts();
  }, []);

  const fetchSavedCharts = async () => {
    try {
      const response = await getSavedCharts();
      if (response && response?.data && response?.data?.status === 200) {
        setSavedCharts(response.data.data.data);
      } else {
      }
    } catch (error) {
      console.error("Error fetching saved posts:", error);
    }
  };

  const handleSlideStart = () => {
    setIsSlide(true);
  };

  const handleSlideEnd = () => {
    setIsSlide(false);
  };

  const handleSavedChartClick = (chart) => {
    setShareChartData(chart);
    setChartId(chart?.id);
    setShareChartData1(chart);
    setActiveImage(chart?.image);
    setPreview(true);
  };
  const [showModal, setShowModal] = useState(false);
  const [showModalChart, setShowModalChart] = useState(false);

  const [chartToDelete, setChartToDelete] = useState(null);

  const handleDeleteChart = async () => {
    try {
      const response = await deleteSavedChart(chartToDelete.id);
      if (response?.data?.data) {
        console.log(response);
        toast.success(response.data.message);
        fetchSavedCharts();
      }
    } catch (error) {
      console.error("Error deleting saved chart:", error);
    } finally {
      setShowModal(false);
    }
  };

  const onShareChartDeleteClick = (chart) => {
    setChartToDelete(chart);
    setShowModal(true);
  };

  useEffect(() => {
    try {
      if (Object.keys(candleStick).length > 0) {
        const mergedResponse = candleStick.Date.map((date, index) => {
          const mainObject = {
            key: index,
            date: new Date(date),
            open: candleStick.Open[index],
            high: candleStick.High[index],
            low: candleStick.Low[index],
            close: candleStick.Close[index],
            volume: candleStick.Volume[index],
            chart: [],
            indicators: [],
          };

          indicators.map((indicator, i) => {
            switch (indicator.type) {
              case "adl":
                mainObject["indicators"][i] = {
                  adl: {
                    ad: indicator.data?.[index]?.AD ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "adx":
                mainObject["indicators"][i] = {
                  adx: {
                    adx: indicator.data?.[index]?.ADX ?? null,
                    dmn: indicator.data?.[index]?.DMN ?? null,
                    dmp: indicator.data?.[index]?.DMP ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "cci":
                mainObject["indicators"][i] = {
                  cci: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    cci: indicator.data?.[index]?.CCI ?? null,
                  },
                };
                break;
              case "cmf":
                mainObject["indicators"][i] = {
                  cmf: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    cmf: indicator.data?.[index]?.CMF ?? null,
                  },
                };
                break;
              case "macd":
                mainObject["indicators"][i] = {
                  macd: {
                    macd: indicator.data?.[index]?.MACD ?? null,
                    macdh: indicator.data?.[index]?.MACDh ?? null,
                    macds: indicator.data?.[index]?.MACDs ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "macdh":
                mainObject["indicators"][i] = {
                  macdh: {
                    data: indicator.data,
                    date: indicator.data?.[index]?.timestamp ?? null,
                    macdh: indicator.data?.[index]?.MACDh ?? null,
                  },
                };
                break;
              case "mfi":
                mainObject["indicators"][i] = {
                  mfi: {
                    mfi: indicator.data?.[index]?.MFI ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "obv":
                mainObject["indicators"][i] = {
                  obv: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    obv: indicator.data?.[index]?.OBV ?? null,
                  },
                };
                break;
              case "ppo":
                mainObject["indicators"][i] = {
                  ppo: {
                    ppo: indicator.data?.[index]?.PPO ?? null,
                    ppoh: indicator.data?.[index]?.PPOh ?? null,
                    ppos: indicator.data?.[index]?.PPOs ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "pvo":
                mainObject["indicators"][i] = {
                  pvo: {
                    pvo: indicator.data?.[index]?.PVO ?? null,
                    pvoh: indicator.data?.[index]?.PVOh ?? null,
                    pvos: indicator.data?.[index]?.PVOs ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "roc":
                mainObject["indicators"][i] = {
                  roc: {
                    roc: indicator.data?.[index]?.ROC ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "efi":
                mainObject["indicators"][i] = {
                  efi: {
                    efi: indicator.data?.[index]?.EFI ?? null,
                    date: indicator.data?.[index]?.timestamp ?? null,
                  },
                };
                break;
              case "stoch":
                mainObject["indicators"][i] = {
                  stoch: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    stoch: indicator.data?.[index]?.STOCHk ?? null,
                  },
                };
                break;
              case "rsi":
                mainObject["indicators"][i] = {
                  rsi: {
                    date: indicator.data?.[index]?.timestamp ?? null,
                    rsi: indicator.data?.[index]?.RSI ?? null,
                  },
                };
                break;
            }
          });
          overlays.map((overlay, i) => {
            switch (overlay.type) {
              case "bb":
                mainObject["chart"][i] = {
                  bb: {
                    top: overlay.data.BBU?.[index] ?? null,
                    middle: overlay.data.BBM?.[index] ?? null,
                    bottom: overlay.data.BBL?.[index] ?? null,
                  },
                };
                break;
              case "sma":
                mainObject["chart"][i] = {
                  sma: {
                    sma: overlay.data?.SMA?.[index] ?? null,
                    close: overlay.data?.Close?.[index] ?? null,
                    date: overlay.data?.Date?.[index] ?? null,
                  },
                };
                break;
              case "ema":
                mainObject["chart"][i] = {
                  ema: {
                    ema: overlay.data?.EMA?.[index] ?? null,
                    close: overlay.data?.Close?.[index] ?? null,
                    date: overlay.data?.Date?.[index] ?? null,
                  },
                };
                break;
              case "psar":
                mainObject["chart"][i] = {
                  psar: {
                    date: overlay.data?.[index]?.timestamp ?? null,
                    psarl: overlay.data?.[index]?.PSARl ?? null,
                    psars: overlay.data?.[index]?.PSARs ?? null,
                  },
                };
                break;
            }
          });
          return mainObject;
        });
        setOverlayloader(false);
        // setIndicatorData(false);

        setData(mergedResponse);
        setloader(false);
      }
    } catch (error) {
      seterror(
        error?.message ? "Something went wrong; please refresh the screen" : ""
      );
      setloader(false);
      console.error("Error occured while getting correct formate", error);
    }
  }, [overlays, candleStick, indicators]);

  useEffect(() => {
    saveStateToLocalStorage(setting);
  }, [setting]);

  function scrollToOptions() {
    // Get the element with the specified class name
    const element = document.querySelector(`.chart-options`);

    // Get the element's top position relative to the document
    const elementTop = element.offsetTop;

    // Scroll to the element smoothly
    window.scrollTo({
      top: elementTop,
      behavior: "smooth",
    });
  }

  function openAnnotations() {
    setSetting((prevSetting) => ({
      ...prevSetting,
      ["drawMode"]: !setting.drawMode,
    }));
  }

  const formatMarketCap = (value) => {
    const suffixes = ["", "K", "M", "B", "T"];
    const suffixNum = Math.floor(("" + value).length / 3);
    let shortValue = parseFloat(
      (suffixNum !== 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(
        2
      )
    );
    if (shortValue % 1 !== 0) {
      shortValue = shortValue.toFixed(2);
    }
    return shortValue + (suffixes[suffixNum] ?? "");
  };
  const isMobileView = document.body.clientWidth <= 768;

  const periods = [
    { id: 1, display: "1min", internal: "minute", period: "1m", multiplier: 1 },
    { id: 2, display: "2min", internal: "minute", period: "2m", multiplier: 2 },
    { id: 3, display: "5min", internal: "minute", period: "5m", multiplier: 5 },
    {
      id: 4,
      display: "15min",
      internal: "minute",
      period: "15m",
      multiplier: 15,
    },
    {
      id: 5,
      display: "30min",
      internal: "minute",
      period: "30m",
      multiplier: 30,
    },
    { id: 6, display: "1h", internal: "hour", period: "1h", multiplier: 1 },
    { id: 7, display: "4h", internal: "hour", period: "4h", multiplier: 4 },
    { id: 8, display: "1D", internal: "day" },
    { id: 9, display: "1W", internal: "week" },
    { id: 10, display: "1M", internal: "month" },
  ];
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrow: true,
    slidesToShow: isMobileView ? 1 : 3,
    slidesToScroll: 1,
    prevArrow: !isMobileView && (
      <ArrowButton imgSrc={faChevronLeft} type="left" isMobileView={isWidth} />
    ),
    nextArrow: !isMobileView && (
      <ArrowButton
        imgSrc={faChevronRight}
        type="right"
        isMobileView={isWidth}
      />
    ),
  };

  const [scButton, setScButton] = useState(false);

  //const apiKey = process.env.REACT_APP_API_KEY;
  const apiKey = process.env.REACT_APP_API_KEY;
  useEffect(() => {
    // const ws = new WebSocket("wss://business.polygon.io/stocks");

      let wsPath = "stocks";
  if (tickerFromLocalStorage.startsWith("C:")) {
    wsPath = "forex";
  } else if (tickerFromLocalStorage.startsWith("X:")) {
    wsPath = "crypto";
  }

  const ws = new WebSocket(`wss://business.polygon.io/${wsPath}`);

    ws.onopen = () => {
      ws.send(JSON.stringify({ action: "auth", params: apiKey }));
      ws.send(
        JSON.stringify({
          action: "subscribe",
          params: `FMV.${tickerFromLocalStorage}`,
        })
      );
      ws.send(
        JSON.stringify({
          action: "subscribe",
          params: `Q.${tickerFromLocalStorage}`,
        })
      );
      ws.send(
        JSON.stringify({
          action: "subscribe",
          params: `AM.${tickerFromLocalStorage}`,
        })
      );
    };

    ws.onmessage = (event) => {
      const response = JSON.parse(event.data);
      response.forEach((msg) => {
        if (msg.ev === "FMV") {
          setStockPrice(msg.fmv ? msg.fmv.toFixed(2) : "N/A");
        } else if (msg.ev === "Q") {
          setQuotes(msg);
        } else if (msg.ev === "AM") {
        }
      });
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error: ", error);
    };

    return () => {
      ws.close();
    };
  }, [apiKey, tickerFromLocalStorage]);

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} setLoader={setloaders} />
      <PageHeaderTitle title={"Chart Search"} />
      <PageContainer>
        {loaders ? <Loader /> : ""}
        {data.length > 0 ? (
          <>
            <ChartTopSummary
              mobileView={isMobileView}
              stockData={stockData}
              tickerFromLocalStorage={tickerFromLocalStorage}
              setting={setting}
              stockPrice={stockPrice}
            />
            <div id="chart-component" className="m-[-2px]">
              <div
                className="grow shrink relative top-4"
                id="chart-container"
                ref={captureRef}
              >
                <Annotation
                  setting={setting}
                  setSetting={setSetting}
                  drawingCanva={drawingCanva}
                />
                <ChartComp
                  initialData={data}
                  setting={setting}
                  indicatorConfig={indicatorConfig}
                  drawingCanva={drawingCanva}
                  gridSetting={gridSetting}
                  setSetting={setSetting}
                  setIndicatorConfig={setIndicatorConfig}
                  symbol={
                    tickerFromLocalStorage
                      ? tickerFromLocalStorage
                      : setting.symbol
                  }
                />
              </div>
            </div>

            <div
              className={
                isMobileView ? "chart-tools mt-8 ml-4" : "chart-tools mt-4 ml-4"
              }
            >
              <ChartToolBar
                periods={periods}
                callbackfn={(period) => (
                  <TimeRangeButton
                    key={period?.id}
                    period={period}
                    setting={setting}
                    onClick={() => {
                      setSetting({
                        ...setting,
                        period: period?.internal,
                        multiplier: period?.multiplier,
                        periodID: period?.id,
                      });
                      setIsParamSubmit(!isParamsSubmit);
                    }}
                  />
                )}
                onClick={openAnnotations}
                onClick1={scrollToOptions}
              />
            </div>
            <StockSummary
              stockData={stockData}
              formatMarketCap={formatMarketCap(stockData?.ticker?.mkt_cap)}
            />

            <ChartActionButtons
              onClick={() => setIsNotificationOpen(true)}
              onClick1={captureElement}
            />
            <div
              className="justify-center flex-nowrap mt-4 overflow-x-auto grid grid-cols-1 lg:grid-cols-9 chart-options"
              style={{
                paddingBottom: isMobileView
                  ? savedCharts.length === 0
                    ? "70px"
                    : "20px"
                  : "40px",
              }}
            >
              <ChartSettingsControl
                setting={setting}
                setSetting={setSetting}
                className="md:flex-shrink-1"
              />
              <ChartType
                setting={setting}
                setSetting={setSetting}
                className="md:flex-shrink-1"
              />
              <Overlays
                setting={setting}
                setSetting={setSetting}
                isSubmit={isOverlaySubmit}
                setIsSubmit={setIsOverlaySubmit}
                loader={overlayloader}
                className="md:flex-shrink-1"
              />
              <Indicators
                setting={setting}
                setSetting={setSetting}
                isSubmit={isIndicatorSubmit}
                setIsSubmit={setIsIndicatorSubmit}
                loader={indicatorloader}
                className="md:flex-shrink-1"
                setRows={setRows}
                rows={rows}
                initialState={initialState}
              />
            </div>
          </>
        ) : (
          <ChartError error={error} />
        )}
        <SavedCharts
          data={data}
          savedCharts={savedCharts}
          mobileView={isMobileView}
          settings={settings}
          onTouchStart={handleSlideStart}
          onTouchEnd={handleSlideEnd}
          callbackfn={(chart, index) => (
            <SaveChartImage
              key={index}
              chart={chart}
              slide={isSlide}
              prop2={() => { }}
              prop3={() => {
                handleSavedChartClick(chart);
              }}
              type={1}
              toggleDropdown1={toggleDropdown1}
              dropdownStates1={dropdownStates1}
              onShareChartClick={onShareChartClick}
              shareChartAsPost={shareChartAsPost}
              index={index}
              onShareChartDeleteClick={onShareChartDeleteClick}
            />
          )}
          callbackfn1={(chart, index) => (
            <SaveChartImage
              key={index}
              chart={chart}
              slide={isSlide}
              prop2={() => { }}
              prop3={() => {
                handleSavedChartClick(chart);
              }}
              type={2}
              onShareChartClick={onShareChartClick}
              shareChartAsPost={shareChartAsPost}
              toggleDropdown1={toggleDropdown1}
              dropdownStates1={dropdownStates1}
              index={index}
              onShareChartDeleteClick={onShareChartDeleteClick}
            />
          )}
          preview={preview}
          onClick={() => {
            setPreview(false);
          }}
          src={activeImage}
          onShareChartClick={onShareChartClick}
          shareChartAsPost={shareChartAsPost}
        />
        {showModal && (
          <div className="fixed z-50 inset-0 overflow-y-auto">
            <div className="absolute inset-0 bg-black opacity-75"></div>

            <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
              <div
                className="fixed inset-0 transition-opacity"
                aria-hidden="true"
              >
                <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>

              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <div className="px-2 fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
                <div className="bg-white rounded-lg  w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
                  {/* Logo */}
                  <div className="flex justify-center items-center mb-4">
                    <img
                      src={"/qushi_logo.png"}
                      alt="Logo"
                      className="h-16 w-auto"
                    />
                  </div>

                  <h2 className="text-lg font-bold text-primaryColor mb-4">
                    Are you sure you want to delete this chart?
                  </h2>

                  <div className="flex items-center justify-between">
                    <button
                      className="bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      onClick={handleDeleteChart}
                    >
                      Yes
                    </button>
                    <button
                      className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      onClick={() => setShowModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showModalChart && (
          <div className="fixed z-50 inset-0 overflow-y-auto">
            <div className="absolute inset-0 bg-black opacity-75"></div>

            <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
              <div
                className="fixed inset-0 transition-opacity"
                aria-hidden="true"
              >
                <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>

              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <div className="px-2 fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
                <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6">
                  {/* Logo */}
                  <div className="flex justify-center items-center mb-4">
                    <img
                      src={"/qushi_logo.png"}
                      alt="Logo"
                      className="h-16 w-auto"
                    />
                  </div>

                  {/* Prompt */}
                  {/* Replaced h2 with input field */}
                  {/* <input
                    type="text"
                    className="text-lg font-bold text-primaryColor mb-4 p-2 border border-gray-300 rounded focus:outline-none focus:border-primaryColor w-full h-24"
                    placeholder="Add Description for chart"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                  /> */}
                  <textarea
                    className="w-full h-64 p-4 text-lg font-medium text-primaryColor border border-gray-300 rounded focus:outline-none focus:border-primaryColor resize-none mb-4"
                    placeholder="Add Description for chart"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                  />


                  <div className="flex items-center justify-between">
                    <button
                      className="bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      onClick={handleShare}
                      disabled={sharingInProgress} // Disable the button when sharing is in progress
                    >
                      Share
                    </button>
                    <button
                      className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      onClick={() => setShowModalChart(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </PageContainer>

      <AddNotification
        open={isNotificationOpen}
        handleClose={handleClose}
        handleSaveNotification={handleSaveNotification}
        handleAPICall={handleAPICall}
        activeTab={activeTab}
        onClick={() => handleTabClick(1)}
        onClick1={() => handleTabClick(2)}
        value={price}
        onChange={handleInputChange}
      />
      <FollowersListModal
        isOpen={isFollowersOpen}
        // handleShareToFollowers={handleShareToFollowers}
        handleShareCancel={handleShareCancel}
      >
        <div>
          <ul className="px-4 max-h-80 overflow-auto mb-2">
            {followersList && followersList.length > 0 ? (
              followersList.map((val, index) => {
                return (
                  <li key={val?.sender?.id} className="">
                    <div className="flex justify-between py-2 bg-gray-100 px-2 rounded-lg mb-4">
                      <div className="flex px-1">
                        <img
                          alt="profile_image"
                          className="object-cover rounded-full w-10 h-10"
                          src={val?.sender?.image}
                        />
                        <p className="px-1 ml-1 mt-2">
                          {val?.sender?.user_name}
                        </p>
                      </div>
                      <div className="px-1">
                        <button
                          disabled={
                            selectedIndices.includes(index) ? true : false
                          }
                          className={
                            selectedIndices.includes(index)
                              ? "text-primaryColor border border-primaryColor rounded-lg px-2 py-2 text-sm cursor-pointer"
                              : "text-white bg-primaryColor rounded-lg px-2 py-2 text-sm cursor-pointer"
                          }
                          onClick={() =>
                            handleShareToFollowers(val?.sender?.id, index)
                          }
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </li>
                );
              })
            ) : (
              <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                <p>No Followers Found</p>
              </div>
            )}
          </ul>
        </div>
      </FollowersListModal>
      {preview1 && (
        <div
          className="flex"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={handlePreview1Close}
        >
          <img
            src={activeImage1}
            alt="Preview"
            style={{ maxWidth: "80%", maxHeight: "90%" }}
          />
        </div>
      )}
    </>
  );
};

const ArrowButton = ({ imgSrc, onClick, type, isMobileView }) => {
  return (
    <button
      onClick={onClick}
      className={
        isMobileView
          ? `absolute top-1/2 z-10 -translate-y-1/2 cursor-pointer ${type === "left"
            ? " left-7 lg:left-[-25px]"
            : "right-4 lg:right-[-25px]"
          } rounded-full p-2 transition duration-150 ease-in-out`
          : `absolute top-1/2 z-10 -translate-y-1/2 cursor-pointer ${type === "left"
            ? "left-5 lg:left-[-25px]"
            : "right-4 lg:right-[-25px]"
          } rounded-full p-2 transition duration-150 ease-in-out`
      }
      style={{
        marginTop: "-12px",
        marginLeft: type === "left" && isMobileView ? "-42px" : "12px",
        marginRight: type === "right" && isMobileView ? "-35px" : "12px",
      }}
    >
      <FontAwesomeIcon className="text-[#5f5f5f]" icon={imgSrc} size="sm" />
    </button>
  );
};

export default Char;
